const secondsLeft = (initialSeconds: number, initialSecondsReceivedAt: Date) => {
  const passedMillis = (new Date().getTime()) - initialSecondsReceivedAt.getTime()
  const left = initialSeconds - Math.floor(passedMillis / 1000)
  return left < 0 ? 0 : left
}

export default secondsLeft
